import { useState } from "react";
import axios from "axios";
import Global from "../Global";
const UseFetchData = () => {
  const [response, setResponse] = useState([]);
  
  const fetchData = async (uri, params) => {
    console.log(Global.BASE_URL + uri)
    console.log(params)
    const resp = await axios({
      url: Global.BASE_URL + uri,
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      data: params,
    });
    setResponse(resp.data);
  };
  debugger; 
  return [response, fetchData];
};

export default UseFetchData;
